import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { TARIFF_LIST_COLUMN_LABEL_I18N_KEY } from '../tariff-list/tariff-list.config';
import { useTariffListContext } from '../tariff.context';

export const TariffListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useTariffListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={TARIFF_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
